import api from './api';

export interface FeatureFlag {
  id: string;
  flag_name: string;
  is_enabled: boolean;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface PublicFeatureFlags {
  publishing: boolean;
  scheduling: boolean;
  social_analytics: boolean;
  social_connections: boolean;
}

class FeatureFlagService {
  async getAllFlags(): Promise<FeatureFlag[]> {
    const response = await api.get('/feature-flags/');
    return response.data;
  }

  async getPublicFlags(): Promise<PublicFeatureFlags> {
    const response = await api.get('/feature-flags/public');
    return response.data;
  }

  async updateFlag(flagName: string, isEnabled: boolean): Promise<FeatureFlag> {
    const response = await api.put(`/feature-flags/${flagName}`, {
      is_enabled: isEnabled
    });
    return response.data;
  }

  async bulkUpdateFlags(updates: Record<string, boolean>): Promise<void> {
    await api.post('/feature-flags/bulk-update', updates);
  }

  async notifyWaitlist(feature: string): Promise<{ message: string }> {
    const response = await api.post(`/feature-flags/notify`, { feature });
    return response.data;
  }
}

export const featureFlagService = new FeatureFlagService();